import { useEffect } from "react";
import { useLocation } from "react-router";

export function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    import("@/lib/analytics").then(({ trackPageView }) => {
      trackPageView(window.location.href);
    });
  }, [location.pathname]);

  return null;
}
